export * as Noise from './mask.png';
